
export const clearAll = (dispatch) => {
    dispatch({ type: "IMAGE_SET_IMAGE", image: '' });
    dispatch({ type: "IMAGE_SET_NAME", name: '' });
    dispatch({ type: "IMAGE_SET_FORMAT", format: '' });
    dispatch({ type: "IMAGE_SET_DIMENSION", width: 0, height: 0 });
    dispatch({ type: "IMAGE_SET_PROPORTIONS", properties: true});
    dispatch({ type: 'CANVAS_SET_IMAGE', image: '' });
    dispatch({ type: 'CANVAS_SET_FORMAT', format: 'image/jpeg' });
    dispatch({ type: 'CANVAS_SET_DIMENSION', height: 0, width: 0 });
    dispatch({ type: 'CANVAS_SET_POSITION', x: 0, y: 0 });
    dispatch({ type: 'CANVAS_SET_IS_CHANGED', isChanged: false });
    dispatch({ type: 'CANVAS_SET_ROTATED', rotationAngle: 0 });
    dispatch({ type: "CANVAS_SET_FLIP_VERTICAL", isFlipVertical: false});
    dispatch({ type: "CANVAS_SET_FLIP_HORIZONTAL", isHorizontal: false });
    dispatch({ type: "SET_VISIBLE_POPUP", isVisible: false });   
    dispatch({ type: "SET_SELECTED_POPUP", selectedPopup: undefined });
    dispatch({ type: "PREVIEW_SET_CATEGORY", category: 'facebook' });
    dispatch({ type: "PREVIEW_SET_ITEMS", items: [] });
    dispatch({ type: "PREVIEW_SET_SELECTED", selected: [] });
    dispatch({ type: "SET_INDEX_UPDATE_PREVIEW", index: undefined });
    dispatch({ type: "PREVIEW_SET_POSITION", previewPosition: [] });
    dispatch({ type: "SET_ERROR", error: null });
    dispatch({ type: "SET_WARNING_WIDTH", warningWidth: null });
    dispatch({ type: "SET_WARNING_HEIGHT", warningHeight: null });
}